import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=e0a2cb72&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=e0a2cb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a2cb72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0a2cb72')) {
      api.createRecord('e0a2cb72', component.options)
    } else {
      api.reload('e0a2cb72', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=e0a2cb72&scoped=true&", function () {
      api.rerender('e0a2cb72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25UFeUU46JgMz/JS/comp/PopupBox.vue"
export default component.exports